import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import DefListColumn from 'components/DefListColumn';
import styles from './styles.css';
import messages from './messages';

const TravelRuleDetailsPanel = ({
  originatingInstitutionName,
  originatingInstitutionAccountNumber,
  recipientInstitutionName,
  recipientInstitutionAccountNumber,
  originatorFirstName,
  originatorLastName,
  originatorAddress,
  originatorEntityName,
  recipientFirstName,
  recipientLastName,
  recipientAddress,
  recipientEntityName,
}) => (
  <div className={styles.panel}>
    <div data-test-handle="originatorSection">
      <div className={styles.sectionHeader}>{<FormattedMessage {...messages.originatorTitle} />}</div>
      <div className={styles.leftPane}>
        <DefListColumn
          className={styles.defList}
          title={<FormattedMessage {...messages.institutionName} />}
          data={originatingInstitutionName}
          dataTestHandle="travelRulesPanel__originatorInstitution"
        />
        <DefListColumn
          className={styles.longDataDefList}
          title={<FormattedMessage {...messages.institutionAccountNumber} />}
          data={originatingInstitutionAccountNumber}
          dataTestHandle="travelRulesPanel__originatorAccount"
        />
      </div>
      <div className={styles.rightPane}>
        {originatorEntityName ? (
          <DefListColumn
            className={styles.defList}
            title={<FormattedMessage {...messages.entityName} />}
            data={originatorEntityName}
            dataTestHandle="travelRulesPanel__originatorEntityName"
          />
        ) : (
          <React.Fragment>
            <DefListColumn
              className={styles.defList}
              title={<FormattedMessage {...messages.firstName} />}
              data={originatorFirstName}
              dataTestHandle="travelRulesPanel__originatorFirstName"
            />
            <DefListColumn
              className={styles.defList}
              title={<FormattedMessage {...messages.lastName} />}
              data={originatorLastName}
              dataTestHandle="travelRulesPanel__originatorLastName"
            />
          </React.Fragment>
        )}
        <DefListColumn
          className={styles.longDataDefList}
          title={<FormattedMessage {...messages.address} />}
          data={originatorAddress}
          dataTestHandle="travelRulesPanel__originatorAddress"
        />
      </div>
    </div>
    <div data-test-handle="recipientSection">
      <div className={styles.sectionHeader}>{<FormattedMessage {...messages.recipientTitle} />}</div>
      <div className={styles.leftPane}>
        <DefListColumn
          className={styles.defList}
          title={<FormattedMessage {...messages.institutionName} />}
          data={recipientInstitutionName}
          dataTestHandle="travelRulesPanel__recipientInstitution"
        />
        <DefListColumn
          className={styles.longDataDefList}
          title={<FormattedMessage {...messages.institutionAccountNumber} />}
          data={recipientInstitutionAccountNumber}
          dataTestHandle="travelRulesPanel__recipientAccount"
        />
      </div>
      <div className={styles.rightPane}>
        {recipientEntityName ? (
          <DefListColumn
            className={styles.defList}
            title={<FormattedMessage {...messages.entityName} />}
            data={recipientEntityName}
            dataTestHandle="travelRulesPanel__recipientEntityName"
          />
        ) : (
          <React.Fragment>
            <DefListColumn
              className={styles.defList}
              title={<FormattedMessage {...messages.firstName} />}
              data={recipientFirstName}
              dataTestHandle="travelRulesPanel__recipientFirstName"
            />
            <DefListColumn
              className={styles.defList}
              title={<FormattedMessage {...messages.lastName} />}
              data={recipientLastName}
              dataTestHandle="travelRulesPanel__recipientLastName"
            />
          </React.Fragment>
        )}
        <DefListColumn
          className={styles.longDataDefList}
          title={<FormattedMessage {...messages.address} />}
          data={recipientAddress}
          dataTestHandle="travelRulesPanel__recipientAddress"
        />
      </div>
    </div>
  </div>
);

TravelRuleDetailsPanel.propTypes = {
  originatingInstitutionName: PropTypes.string.isRequired,
  originatingInstitutionAccountNumber: PropTypes.string.isRequired,
  recipientInstitutionName: PropTypes.string.isRequired,
  recipientInstitutionAccountNumber: PropTypes.string.isRequired,
  originatorFirstName: PropTypes.string.isRequired,
  originatorLastName: PropTypes.string.isRequired,
  originatorAddress: PropTypes.string.isRequired,
  originatorEntityName: PropTypes.string.isRequired,
  recipientFirstName: PropTypes.string.isRequired,
  recipientLastName: PropTypes.string.isRequired,
  recipientAddress: PropTypes.string.isRequired,
  recipientEntityName: PropTypes.string.isRequired,
};

export default TravelRuleDetailsPanel;



// WEBPACK FOOTER //
// ./src/components/TravelRuleDetailsPanel/index.js